// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12974":"skin-copy","50169":"aria-labels"}[chunkId] || chunkId) + "-" + {"2387":"23f93e189768a8438081","12974":"2ccceb552392104a3842","24910":"3f7db77a1d14c695acf4","25870":"1b33b838e87d50d2a62d","50169":"d24e92b78b22be57f8de","79302":"1f876c523dfc449c9ff1"}[chunkId] + ".min.js";
};